/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem
 */
export interface DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    delivery_hours?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem
     */
    sort_order?: number;
}

export function DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSON(json: any): DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem {
    return DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'delivery_hours': !exists(json, 'delivery_hours') ? undefined : json['delivery_hours'],
        'sort_order': !exists(json, 'sort_order') ? undefined : json['sort_order'],
    };
}

export function DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItemToJSON(value?: DigitizingMelcoDigitizingModelsDigitizingDeliveryOptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'delivery_hours': value.delivery_hours,
        'sort_order': value.sort_order,
    };
}


